/**
 * VyV Conseil MRH Public API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Saisie des informations sur le logement
 */
export interface VyVTarifSaisieHabitation {
  TypeHabitation: VyVTarifSaisieHabitation.TypeHabitationEnum;
  QualiteOccupant: VyVTarifSaisieHabitation.QualiteOccupantEnum;
  NatureResidence: VyVTarifSaisieHabitation.NatureResidenceEnum;
  TarifPreferentiel: boolean;
  CompositionFoyer: number | null;
  RFRInferieurPlafond: boolean | null;
  ConfirmationRFRInferieurPlafond: boolean | null;
  NombrePieces: number | null;
  NombrePiecesSuperieures: number | null;
  Etage: VyVTarifSaisieHabitation.EtageEnum;
  AvecVeranda: boolean | null;
  AntecedentSinistresInondables: boolean | null;
  SurfaceDependance: VyVTarifSaisieHabitation.SurfaceDependanceEnum | null;
  InstallationDD: boolean | null;
  PiscineSpaJacuzzi: boolean | null;
  ObjetsValeurSuperieur2000: boolean | null;
  PlafondMobilier: VyVTarifSaisieHabitation.PlafondMobilierEnum;
  MontantPlafondMobilier: number | null;
  TypeChambre: string | null;
  NombreColocataires: number | null;
}
export namespace VyVTarifSaisieHabitation {
  export type TypeHabitationEnum = 'Apartment' | 'House' | 'Room' | 'Unnkown';
  export const TypeHabitationEnum = {
    Appartement: 'Apartment' as TypeHabitationEnum,
    Maison: 'House' as TypeHabitationEnum,
    Chambre: 'Room' as TypeHabitationEnum,
    Autre: 'Unnkown' as TypeHabitationEnum
  };
  export type QualiteOccupantEnum = 'Owner' | 'Tenant';
  export const QualiteOccupantEnum = {
    Proprietaire: 'Owner' as QualiteOccupantEnum,
    Locataire: 'Tenant' as QualiteOccupantEnum
  };
  export type NatureResidenceEnum = 'Principal' | 'Secondary';
  export const NatureResidenceEnum = {
    Principale: 'Principal' as NatureResidenceEnum,
    Secondaire: 'Secondary' as NatureResidenceEnum
  };
  export type EtageEnum = 'GroundFloor' | 'MiddleFloor' | 'TopFloor' | 'None';
  export const EtageEnum = {
    RezDeChaussee: 'GroundFloor' as EtageEnum,
    Intermediaire: 'MiddleFloor' as EtageEnum,
    DernierEtage: 'TopFloor' as EtageEnum,
    None: 'None' as EtageEnum
  };
  export type SurfaceDependanceEnum = 'None' | '_0_50m2' | '_0_40m2' | '_50_100m2' | '_100_250m2';
  export const SurfaceDependanceEnum = {
    Aucune: 'None' as SurfaceDependanceEnum,
    MoinsDe50m2: '_0_50m2' as SurfaceDependanceEnum,
    MoinsDe40m2: '_0_40m2' as SurfaceDependanceEnum,
    De50a100m2: '_50_100m2' as SurfaceDependanceEnum,
    PlusDe100m2: '_100_250m2' as SurfaceDependanceEnum
  };
  export type PlafondMobilierEnum = 'F1' | 'F2';
  export const PlafondMobilierEnum = {
    F1: 'F1' as PlafondMobilierEnum,
    F2: 'F2' as PlafondMobilierEnum
  };

  export type VerandaTypeEnum = '_0_10m2' | '_10_40m2' | '_40m2' | 'None';
  export const VerandaTypeEnum = {
    _0_10m2: '_0_10m2' as VerandaTypeEnum,
    _10_40m2: '_10_40m2' as VerandaTypeEnum,
    _40m2: '_40m2' as VerandaTypeEnum,
    None: 'None' as VerandaTypeEnum
  };
}
